import React from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { openModal } from '../../../redux/reducers/modal';
// hoc
import { withRouter } from 'react-router-dom';
// components
import Button from '../../../components/Button/Button';
import Icon from '../../../components/Icon/Icon';
// utils
import get from 'lodash.get';
// styles
import classnames from 'classnames/bind';
import styles from './AddSkillButton.mod.css';

const cn = classnames.bind(styles);

const AddSkillButton = ({ openModal, userColor, location, history }) => {
  const handleClick = () => {
    if (!location.pathname.startsWith('/skills')) history.push('/skills');
    openModal('UPDATE_SKILL', { color: userColor });
  };

  return (
    <Button className={cn('button')} onClick={handleClick} color={userColor}>
      <Icon type="add" className={cn('button-icon', 'icon-add')} />
      Add skill
    </Button>
  );
};

const enhance = compose(
  connect(
    state => ({
      userColor: get(state.auth, 'user.profile_color') || '#33C370'
    }),
    { openModal }
  ),
  withRouter
);

AddSkillButton.propTypes = {
  openModal: T.func.isRequired,
  userColor: T.string.isRequired,
  location: T.shape({
    pathname: T.string
  }),
  history: T.shape({
    push: T.func
  })
};

export default enhance(AddSkillButton);



// WEBPACK FOOTER //
// ./src/containers/Skills/components/AddSkillButton.jsx